import Axios from 'axios';
import { action, observable } from 'mobx';
import { API } from '@/config/api';
import { ScrollPageInfo, PageInfo } from '@/models/data';
import { Notification } from 'element-react';
import qs from 'qs';
import i18n from '@/i18n';
import { transformTime } from '@/utils/fn';

type supportCoinType = {
  coinTypes: any[];
  currencyCoinDisplay: any[];
  currencyCoins: any[];
};

type QuickOrderConfigType = {
  coinType: string;
  currencyCoin: string;
  coinAmountMax: number;
  coinAmountMin: number;
  currencyCoinAmountMax: number;
  currencyCoinAmountMin: number;
};

type QuickAdvertisingParams = {
  gteAmount: number;
  gteCurrencyCoinAmount: number;
  coinType?: string;
  currencyCoinType?: string;
  direction?: string;
  payMethod?: string;
};
export default class OtcConsumer {
  @observable currentOtcName: string;

  @observable supportCoin: supportCoinType;

  @observable quickOrderConfig: QuickOrderConfigType;

  @observable advertisingList: any[];

  @observable tabListPageInfo: PageInfo;

  @observable isFetchingadvertisingList: boolean;
  @observable isfetchBalanceHistoryList: boolean;

  @observable showConfirmOrderModal: boolean;

  @observable direction: string;

  @observable buyType: string;

  @observable buyOrSellState: string;

  @observable quickAdParams: QuickAdvertisingParams;

  @observable rate: string | number;

  @observable adListInfo: any;

  @observable receiptArr: any;

  @observable orderId: any;

  @observable orderInfo: any;

  @observable orderList: any;

  @observable isFetchFollowList: any;

  @observable followListPageInfo: any;

  @observable merchantQuitVerifyObj: any;

  @observable orderReceiptArr: any;

  @observable orderChatList: any;

  @observable unfinishedCount: number;

  @observable balanceHistoryList: any;

  @observable balanceHistoryPageInfo: ScrollPageInfo;

  @observable billTypeArr: any;

  constructor() {
    this.currentOtcName = 'quick';
    this.billTypeArr = [];
    this.balanceHistoryPageInfo = {
      hasPrev: false,
      hasNext: false,
    };
    this.supportCoin = { coinTypes: [], currencyCoinDisplay: [], currencyCoins: [] };
    this.quickOrderConfig = {
      coinType: '',
      currencyCoin: '',
      coinAmountMax: 0,
      coinAmountMin: 0,
      currencyCoinAmountMax: 0,
      currencyCoinAmountMin: 0,
    };
    this.advertisingList = [];
    this.balanceHistoryList = [];
    this.tabListPageInfo = {
      page: 1,
      size: 10,
      total: 0,
    };
    this.isFetchingadvertisingList = false;
    this.isfetchBalanceHistoryList = false;
    this.showConfirmOrderModal = false;
    this.direction = 'B';
    this.buyType = ''; // 购买类型 自选   快捷
    this.buyOrSellState = '-1';
    /* 
      买：

      2 待我支付 ==》待支付      有倒计时  
      desc: 
      订单已经生成 内付款，将自动取消订单。
      转账完成请务必点击“我已完成付款，通知对方”，通知卖家收款。
      btn:我已完成付款，通知对方 		取消订单  
      
    

 
      3  .等待卖家放币==》   等待确认          轮询请求刷新状态
      desc:
      订单已生成，等待卖家放币
      转账完成请务必点击“我已完成付款，通知对方”，通知卖家收款。
      btn:等待卖家确认订单…             置灰


 
      4  .已完成   
      desc: 
      再次下单    没有 步骤1 2   支付方式可以查看

      -1.已取消 之前是4
      desc: 您付款超时，订单已自动取消。  没有 步骤1 2    支付方式不可查看
      btn:再次下单

      5 审核中          轮询请求刷新状态
      订单已生成，审核中
      btn:审核中…            置灰
      -----------------------------


      卖：
      5:审核中          轮询请求刷新状态
      等待买家付款      
      desc: 
      订单已生成，审核中
      收款后请务必点击“我已收到款项，去放币”
      btn:审核中…            置灰


      2.等待买家付款      轮询请求刷新状态
      desc: 
      订单已生成，请等待买家付款
      收款后请务必点击“我已收到款项，去放币”
      btn:等待买家付款…            置灰

      



      3.请确认收款   ==》确认订单         有倒计时（取消了）
      desc:订单已生成，请在xx内收款，如未确认将自动结束订单==>订单已生成，请收款后区放币
      btn:我已收到款项，去放币
      ===》确认弹框



      4. 已完成  有个图标
      desc:您已确认放币，订单完成   没有 步骤1 2   支付方式可以查看
      btn:再次下单



      -1.已取消
      desc: 已为您取消订单==》买家已取消订单    没有 步骤1 2    支付方式不可查看
      btn:再次下单



      都叫核对订单信息

      注意 只有买家可以主动取消
        
        */
    this.rate = ''; // 汇率
    this.quickAdParams = {
      gteAmount: 0, // 代币数量
      gteCurrencyCoinAmount: 0, // 	法币数量
      coinType: '', // 代币
      currencyCoinType: '', // 	法币
      direction: '', //	方向，S,B
      payMethod: '', // 支付方式
    };
    this.adListInfo = {};
    this.receiptArr = [];
    this.orderId = '';
    this.orderInfo = {};
    this.orderList = [];
    this.isFetchFollowList = false;
    this.followListPageInfo = {
      page: 1,
      size: 10,
      total: 0,
    };
    this.merchantQuitVerifyObj = {
      lastOrderOverTenDay: false,
      notAbnormalOrder: false,
      notAdvertising: false,
    };
    this.orderReceiptArr = [];
    this.orderChatList = [];
    this.unfinishedCount = 0;
  }

  @action.bound
  setBillTypeArr(data: any) {
    this.billTypeArr = data;
  }

  @action.bound
  setBalanceHistoryPageInfo(data: ScrollPageInfo) {
    const origin = { ...this.balanceHistoryPageInfo };
    this.balanceHistoryPageInfo = { ...origin, ...data };
  }

  @action.bound
  setUnfinishedCount(data: number) {
    this.unfinishedCount = data;
  }

  @action.bound
  setOrderChatList(data: any) {
    // this.orderChatList = data.sort((a, b) => a.id - b.id);
    this.orderChatList = data;
    if (this.orderChatList.length > 200) {
      this.orderChatList.splice(0, 1);
    }
  }

  @action.bound
  setRrderReceiptArr(data: any) {
    this.orderReceiptArr = data;
  }

  @action.bound
  setMerchantQuitVerifyObj(data: any) {
    this.merchantQuitVerifyObj = data;
  }

  @action.bound
  setOrderList(data: any) {
    this.orderList = data;
  }

  @action.bound
  setOrderInfo(data: any) {
    this.orderInfo = data;
  }

  @action.bound
  setOrderId(data: any) {
    localStorage.setItem('orderId', data);
    this.orderId = data;
  }

  @action.bound
  setAdListInfo(data: any) {
    this.adListInfo = data;
  }

  @action.bound
  setReceiptArr(data: any) {
    this.receiptArr = data;
  }

  @action.bound
  setRate(data: string | number) {
    this.rate = data;
  }

  @action.bound
  changeQuickOrderConfig(data: QuickOrderConfigType) {
    this.quickOrderConfig = data;
  }

  @action.bound
  setQuickAdParams(data: QuickAdvertisingParams) {
    this.quickAdParams = data;
  }

  @action.bound
  changeBuyOrSellState(data: string | number) {
    this.buyOrSellState = data + '';
  }

  @action.bound
  changeBuyType(data: string) {
    this.buyType = data;
  }

  @action.bound
  changeDirection(data: string) {
    this.direction = data;
  }

  @action.bound
  changeCurrentOtcName(data: string) {
    this.currentOtcName = data;
  }

  @action.bound
  changeConfirmOrderModal(flag: boolean) {
    this.showConfirmOrderModal = flag;
  }

  @action.bound
  setSupportCoin(data: supportCoinType) {
    this.supportCoin = data;
  }

  @action.bound
  setAdvertisingList(data: any[]) {
    this.advertisingList = data;
  }

  @action.bound
  setBalanceHistoryList(data: any[]) {
    this.balanceHistoryList = data;
  }

  @action.bound
  setAdvListPageInfo(data: PageInfo) {
    const origin = { ...this.tabListPageInfo };
    this.tabListPageInfo = { ...origin, ...data };
  }

  @action.bound
  setOrderListPageInfo(data: PageInfo) {
    const origin = { ...this.followListPageInfo };
    this.followListPageInfo = { ...origin, ...data };
  }

  @action.bound
  setLoadingState(key: string, data: boolean) {
    // @ts-ignore
    this[key] = data;
  }

  // 获取币对
  @action.bound
  async fetchSupportCoin() {
    const result: any = await Axios.get(API.OTC_AD_SUPP).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });

    });
    if (result) {
      this.setSupportCoin(result);
    }
    return Promise.resolve(result);
  }

  // 快速下单配置
  @action.bound
  async fetchQuickOrderConfig(params?: { coinType?: string; currencyCoin?: string }) {
    const result: any = await Axios.get(API.OTC_AD_QUICKORDER, { params }).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });

    });
    if (result) {
      this.changeQuickOrderConfig(result);
    }
    return Promise.resolve(result);
  }

  @action.bound
  async fetchQuickAdvertising(data: QuickAdvertisingParams) {
    const result: any = await Axios.post(API.OTC_AD_QUICKADVER, qs.stringify(data)).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });
    if (result) {
      return Promise.resolve(result);
    }
  }

  @action.bound
  async fetchOtcOrderCreateV2(data: any) {
    const result: any = await Axios.post(API.OTC_ORDER_CREATV2, qs.stringify(data)).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });
    if (result) {
      this.setOrderId(result);
      return Promise.resolve(result);
    }
  }

  @action.bound
  async fetchAdvertisingList(params: {
    coinType?: string; // 代币
    currencyCoinType?: string; // 法币
    direction?: string; // 方向，S,B
    payMethod?: string; // 支付方式
    page?: number;
    size?: number;
  }) {
    this.setLoadingState('isFetchingadvertisingList', true);
    const tabListPageInfo = this.tabListPageInfo;
    const config: any = {
      params: {
        page: tabListPageInfo.page,
        size: tabListPageInfo.size,
        ...params,
      },
    };
    const result: any = await Axios.get(API.OTC_AD_LIST, config).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });
    if (result) {
      const {
        data,
        pageRequest: { page, size },
        total,
      } = result;
      this.setAdvertisingList(data);
      this.setAdvListPageInfo({ page, size, total });
    }
    this.setLoadingState('isFetchingadvertisingList', false);
    return Promise.resolve(result);
  }

  // 用户流水查询
  @action.bound
  async fetchBalanceHistoryList(params?: {
    id?: string;
    direction?: string; // NEXT PREV
    endTime?: number;
    startTime?: number;
    limit?: number;
  }) {
    this.setLoadingState('isfetchBalanceHistoryList', true);
    const result: any = await Axios.get(API.OTC_HISTOTY_LIST, {
      params: { ...params, ...transformTime('startTime', 'endTime', params?.startTime, params?.endTime) },
    }).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });
    if (result) {
      const { items, hasPrev, hasNext } = result;
      this.setBalanceHistoryList(items);
      this.setBalanceHistoryPageInfo({ hasPrev, hasNext });
    }
    this.setLoadingState('isfetchBalanceHistoryList', false);
    return Promise.resolve(result);
  }

  // 账单类型
  @action.bound
  async fetchBalanceBillType() {
    const result: any = await Axios.get(API.OTC_BALANCE_BILLTYPE).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });
    if (result) {
      this.setBillTypeArr(result);
    }
    return Promise.resolve(result);
  }

  // 广告详情
  @action.bound
  async fetchAdvertisingInfo(params: { id: string }) {
    const result: any = await Axios.get(API.OTC_AD_LIST_INFO, { params }).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });
    if (result) {
      this.setAdListInfo(result);
    }
    return Promise.resolve(result);
  }

  // 修改收付款方式状态
  @action.bound
  async fetchUpdateReceiptStatus(data: any) {
    const result: any = await Axios.post(API.OTC_USER_UPDATERP, qs.stringify(data)).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });
    if (result) {
      Notification.success({
        message: i18n.t('success.adjust'),
        offset: 60,
        duration: 2000,
      });
      this.fetchGetReceipt();
    }
    return Promise.resolve(result);
  }

  // 删除收付款方式
  @action.bound
  async fetchDeleteReceipt(data: any) {
    const result: any = await Axios.post(API.OTC_USER_DELRECRIPT, qs.stringify(data)).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });
    if (result) {
      Notification.success({
        message: i18n.t('common.delSuccess'),
        offset: 60,
        duration: 2000,
      });
      this.fetchGetReceipt();
    }
    return Promise.resolve(result);
  }

  // 获取所有收付款信息
  @action.bound
  async fetchGetReceipt() {
    const result: any = await Axios.get(API.OTC_USER_GETRP).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });
    if (result) {
      this.setReceiptArr(result);
    }
    return Promise.resolve(result);
  }

  // 能否退出商家
  @action.bound
  async fetchMerchantQuitVerify() {
    const result: any = await Axios.get(API.OTC_QUITVERIFY_MARCHANT).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });
    if (result) {
      this.setMerchantQuitVerifyObj(result);
      return Promise.resolve(result);
    }
  }

  // 退出商家
  @action.bound
  async fetchMerchantQuit() {
    const result: any = await Axios.post(API.OTC_QUIT_MARCHANT).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });
    if (result) {
      return Promise.resolve(result);
    }
  }

  // 下单成功后的订单详情
  @action.bound
  async fetchOrderInfo(params: any) {
    const result: any = await Axios.get(API.OTC_ORDER_INFO_GET, { params }).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });
    if (result) {
      this.setOrderInfo(result);
      this.changeBuyOrSellState(result.status);
      this.changeDirection(result.direction);
      return Promise.resolve(result);
    }
  }

  // 我已完成付款，通知对方
  @action.bound
  async fetchOrderConfirmPayment(data: {
    id: string; // 订单id
    payEeRealName: string; // 付款方实名
    receiptId: string; // 	卖出方收付款方式ID
  }) {
    const result: any = await Axios.post(API.OTC_ORDER_CONFIRMPAYMENT, qs.stringify(data)).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });
    if (result) {
      return Promise.resolve(result);
    }
  }

  // 我已收到款项，去放币
  @action.bound
  async fetchOrderConfirmReceipt(data: {
    id: string; // 订单id
  }) {
    const result: any = await Axios.post(API.OTC_ORDER_CONFIRMRECEIPT, qs.stringify(data)).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });
    if (result) {
      return Promise.resolve(result);
    }
  }

  // 取消订单
  @action.bound
  async fetchOrderCancel(data: {
    id: string; // 订单id
  }) {
    const result: any = await Axios.post(API.OTC_ORDER_CANCEL, qs.stringify(data)).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });
    return Promise.resolve(result);
  }

  // 根据订单Id获取卖方收款方式
  @action.bound
  async fetchOrderGetReceipt(params: {
    id: string; // 订单id
  }) {
    const result: any = await Axios.get(API.OTC_ORDER_GETRECEIPT, { params }).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });
    if (result) {
      this.setRrderReceiptArr(result);
      return Promise.resolve(result);
    }
  }

  // 我的订单
  @action.bound
  async fetchOrderList(params: { page?: number; size?: number; status?: string | number; direction?: string }) {
    this.setLoadingState('isFetchFollowList', true);
    const followListPageInfo = this.followListPageInfo;
    const config: any = {
      params: {
        page: followListPageInfo.page,
        size: followListPageInfo.size,
        ...params,
      },
    };

    const result: any = await Axios.get(API.OTC_ORDER_LIST, config).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });

    if (result) {
      const {
        data,
        pageRequest: { page, size },
        total,
      } = result;
      this.setOrderList(data);
      this.setOrderListPageInfo({ page, size, total });
    }
    this.setLoadingState('isFetchFollowList', false);

    return Promise.resolve(result);
  }

  // c2c订单-拉取消息
  @action.bound
  async fetchOrderReplyPull(params: {
    id: string; // 订单id
    replyId: string | number;
  }) {
    const result: any = await Axios.get(API.OTC_ORDER_REPLY_PULL, { params }).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });
    if (result) {
      const idArr = [...new Set(this.orderChatList.map(i => i.id))];
      const newArr = result.filter(i => {
        if (!idArr.includes(i.id)) {
          return i;
        }
      });
      this.setOrderChatList([...this.orderChatList, ...newArr]);
      return Promise.resolve(result);
    }
  }

  // c2c订单-回复列表
  @action.bound
  async fetchOrderReplyList(params: {
    id: string; // 订单id
  }) {
    const result: any = await Axios.get(API.OTC_ORDER_REPLY_LIST, { params }).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });
    if (result) {
      this.setOrderChatList(result);
      return Promise.resolve(result);
    }
  }

  // 创建c2c订单-回复文字
  @action.bound
  async fetchOrderReplyRCreateTxt(data: {
    id: string; // 订单id
    content: string; // 内容
  }) {
    const result: any = await Axios.post(API.OTC_ORDER_REPLY_CREATETXT, qs.stringify(data)).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });
    if (result) {
      return Promise.resolve(result);
    }
  }

  // 创建c2c订单-回复图片
  @action.bound
  async fetchOrderReplyRCreateImg(data: {
    id: string; // 订单id
    file: any;
  }) {
    const result: any = await Axios.post(API.OTC_ORDER_REPLY_CREATEIMG, data, {
      dataType: 'file',
    }).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });
    if (result) {
      return Promise.resolve(result);
    }
  }

  // 未完成订单数
  @action.bound
  async fetchUnfinishedCount() {
    const result: any = await Axios.get(API.OTC_ORDER_UNFINISHEDCOUNT).catch(({ error }: any) => {
      Notification.error({
        message: error,
        offset: 60,
        duration: 2000,
      });
    });
    if (typeof result == 'number') {
      this.setUnfinishedCount(result);
      return Promise.resolve(result);
    }
  }
}
